export default "__VITE_ASSET__d8d577b9__"